angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.sellerOrdersWidgetController', ['$scope', 'platformWebApp.bladeNavigationService', 'virtoCommerce.orderModule.order_res_customerOrders',
        function ($scope, bladeNavigationService, ordersApi) {
            var sellerId = $scope.widget.blade.currentEntity.id;
            
            var searchCriteria = {
                responseGroup: "None",
                employeeId: sellerId,
                skip: 0,
                take: 0
            };
            ordersApi.search(searchCriteria, function (data) {
                $scope.ordersCount = data.totalCount;
            });

            $scope.openBlade = function () {
                var newBlade = {
                    id: 'seller-order-list',
                    title: 'marketplace.blades.seller-order-list.title',
                    searchCriteria: { employeeId: sellerId },
                    controller: 'virtoCommerce.orderModule.customerOrderListController',
                    template: 'Modules/$(VirtoCommerce.Orders)/Scripts/blades/customerOrder-list.tpl.html',
                    isExpanded: true
                };

                bladeNavigationService.showBlade(newBlade, $scope.widget.blade);
            };
        }
    ]);
